import styled from "styled-components";

export const UserIconBox = styled.div`
    width: 15px;
    height: 17px;
    background-size: contain;
    background-repeat: no-repeat;
    background-image: url("${props => props.theme.images.user.welcomePostLoginMobile.toString()}");
    color: ${props => props.theme.colors.brandSecondary};
`